import React, { useState } from 'react'
import useSubmitPayment from './useSubmitPayment'
import { usePaymentStore } from '../PaymentTypeSelection'
import { useInvoiceCompletedStore } from '../../../stores/invoiceCompleted'
import { useSnlInvoiceStore } from '../../../stores/SNLInvoiceStore'
import { PagePropsAbstract } from '../../../components/pageNavigator'
import { BuilderComponent, BuilderContent } from '@builder.io/react'
import { FallbackPaymentAuthorizationNotice } from 'components/builderComponents/payment/components/PaymentAuthorizationNotice'
import { icoLock } from 'resources/images'
import LoadingSpinner from 'components/LoadingSpinner'
import { updateInvoice } from 'modules/aobPayments/fetchPromises'
function SubmitPayment({ paymentAuthorizationNoticeContent, ...pageProps }: { paymentAuthorizationNoticeContent: BuilderContent } & PagePropsAbstract ) {
  const { setInvoiceCompleted } = useInvoiceCompletedStore()
  const { snlInvoice, editedInvoice, setSnlPaymentCompleted, snlInvoiceHash, removedItems } = useSnlInvoiceStore()


  const [ error, setError ] = useState<string>( `` )

  const onSuccess = () => {
    setInvoiceCompleted( true )
    setSnlPaymentCompleted( true )

    return pageProps.nextPage()
  }

  const {
    billingAddressValid,
    isNewCardValid,
    isNewBankValid,
    splitPayment,
    selectedPaymentProfile
  } = usePaymentStore()

  const invoice = editedInvoice ?? snlInvoice

  const { isLoading, submitUpfrontPayment } = useSubmitPayment(
    invoice || undefined,
    onSuccess
  )

  const disabled =
    ( ( !selectedPaymentProfile ||
      ( selectedPaymentProfile === `New Credit Card` &&
        ( !isNewCardValid || !billingAddressValid ) ) ||
      ( selectedPaymentProfile === `New Bank Account` && !isNewBankValid ) ||
      splitPayment === null ) &&
      ( invoice?.total_patient_owes ?? 0 ) > 0 ) ||
    isLoading

  const handleSubmitPayment = async () => {
    if ( removedItems?.length ) updateInvoice( removedItems, snlInvoiceHash )
    if ( invoice?.total_patient_owes ) {
      const paymentResponse = await submitUpfrontPayment( invoice.total_patient_owes )

      if ( paymentResponse?.status !== `success` )
        return setError(
          `There was an error processing your payment. Please try again`
        )
    } else onSuccess()
  }

  return (
    <div
      className="flex flex-col items-center justify-center w-full gap-5 max-w-xl mx-auto px-2 mt-8"
      id="submit-payment"
    >
      <div className="flex items-center justify-center gap-1">
        <img
          src={icoLock}
          alt="lock icon"
          height={20}
          width={20}
        />
        <h1 className="text-xl text-navy tracking-normal text-center font-semibold font-inter">
          {`Secure Payment`}
        </h1>
      </div>

      {
        paymentAuthorizationNoticeContent ? (
          <BuilderComponent
            model="payment-authorization-notice"
            content={paymentAuthorizationNoticeContent as any}
          /> ): <FallbackPaymentAuthorizationNotice />
      }

      <button
        id="submit-payment"
        className="btn-primary py-3 px-8 rounded-md font-medium"
        onClick={handleSubmitPayment}
        disabled={disabled}
        data-testid="snl-submit-payment-button"
      >
        {isLoading ? (
          <div className="flex items-center justify-center mx-auto">
            <LoadingSpinner height="20px" width="20px" rings={3} />
            <span className="pl-2">
              {`Place Order - $${invoice?.total_patient_owes?.toFixed( 2 )}`}
            </span>
          </div>
        ) : (
          <>
            {`Place Order - $${invoice?.total_patient_owes?.toFixed( 2 )}`}
          </>
        )}
      </button>
      {error && (
        <p className="text-error p-3 max-w-lg mx-auto text-center">{error}</p>
      )}
    </div>
  )
}

export default SubmitPayment
